<template>
  <div>
    <v-container fluid grid-list-md>
      <progress-bar :fixed="true"></progress-bar>
      <v-toolbar class="mb-4">
        <v-toolbar-title>
          Track calendar
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <div class="app_filter">
          <v-btn @click="toggleToPrevWeek" class="mr-1" small color="primary" flat><v-icon>keyboard_arrow_left</v-icon>To prev week</v-btn>
          <v-btn @click="toggleToNextWeek" class="ml-1" small color="primary" flat>To next week<v-icon>keyboard_arrow_right</v-icon></v-btn>
          <v-btn @click="toggleCurrentWeek" class="ml-1" small color="info" flat>Current week</v-btn>
          <span class="font-weight-black ml-3 mr-3">Total: {{ totalTime?totalTime: 'Go work!'}}</span>
          <div class="app_filter__item app_filter__item--search" v-if="featureAllowed($features.CALENDAR_SELECT)" >
            <v-select v-model="filterUserId" hide-details dense :items="users" item-text="name" item-value="id" label="Employee"></v-select>
          </div>
        </div>
      </v-toolbar>
      <div class="track-calendar">
        <div class="track-calendar_item" v-for="day in calendar">
          <div class="track-calendar_item__inner">
            <div class="track-calendar_item__header">
              <div><strong>{{ day.title }}</strong> </div>
              <div>{{ day.duration.length > 0 ? day.duration : '0' }} / {{ day.day_normal }}</div>
            </div>
            <div class="track-calendar_item__progress" :style="{ background: day.progress > 0 ? '#607d8b' : '#ff6666' }">
              <span class="track-calendar_item__progress--line" :style="{ width: day.progress + '%' }"></span>
              <span class="track-calendar_item__progress--value">{{ day.progress }}%</span>
            </div>
            <div class="track-calendar_item__body">
                <ul class="track-calendar_tracks" v-if="day.times && day.times.length > 0">
                  <li class="track-calendar_tracks__item" v-for="time in day.times">
                    <div class="track-calendar_tracks__item--head">
                      <span>{{ time.description }}</span>
                    </div>
                    <div class="track-calendar_tracks__item--footer">
                      <div>
                        <span><router-link target="_blank" :to="'/projects/' + time.task.project.id + '/tasks/' + time.task.id">{{ time.task | getText('short_name', 'unspecified') }}</router-link></span>
                        <i style="color: #1bc470" v-if="time.approved"><v-icon color="success" size="16" class="ml-1" title="Is approved">check</v-icon></i>
                        <i style="color: #ff6666" v-else><v-icon color="error" size="16" class="ml-1" title="Is not approved">close</v-icon></i>
                      </div>
                      <div><span>{{ time.duration }}</span></div>
                    </div>
                  </li>
                </ul>
                <ul class="track-calendar_tracks" v-else>
                  <li class="track-calendar_tracks__item">
                    <div class="track-calendar_tracks__item--empty">No data</div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

    </v-container>
  </div>
</template>

<script>
  import * as mixins from '@/mixins/'
  import moment from 'moment'

  export default {
    name: 'TrackCalendar',
    mixins: [mixins.preloader, mixins.user],
    data() {
      return {
        filter: {
          from: moment().startOf('isoWeek').format("YYYY-MM-DD"),
          to: moment().endOf('isoWeek').format("YYYY-MM-DD"),
        },
        users: [],
        filterUserId: '',
        reports: [],
        calendar: [],
        totalTime: ''
      }
    },
    methods: {
      getReport() {
        let params = {}

        if(this.user.role_id == '3') {
          params = {...this.filter}
        } else {
          params = {...this.filter, user_id: this.filterUserId}
        }

        return this.$api.reports.calendar(params).then(({data}) => {
          this.reports = data.days
          this.totalTime = data.total_duration
          this.calendar = []
          for(let i = 0; i < 7; i++) {
            let suggess = this.reports[moment(this.filter.from).add(i, 'days').format("YYYY-MM-DD")]
            if(suggess) {
              this.calendar.push({
                title: moment(this.filter.from).add(i, 'days').format("YYYY-MM-DD"),
                ...suggess
              })
            } else {
              this.calendar.push({
                title: moment(this.filter.from).add(i, 'days').format("YYYY-MM-DD"),
              })
            }

          }
        })
      },
      getUsers() {
        let params = {
          unlimit: 1
        }

        if(this.featureAllowed(this.$features.CALENDAR_SELECT)) {
          return this.$api.users.list(params).then(response => {
            this.users = response.data.data ? response.data.data : response.data
          })
        }
      },
      toggleToPrevWeek() {
        this.filter.from = moment(this.filter.from).subtract(7, 'days').format("YYYY-MM-DD")
        this.filter.to = moment(this.filter.to).subtract(7, 'days').format("YYYY-MM-DD")
      },
      toggleToNextWeek() {
        this.filter.from = moment(this.filter.from).add(7, 'days').format("YYYY-MM-DD")
        this.filter.to = moment(this.filter.to).add(7, 'days').format("YYYY-MM-DD")
      },
      toggleCurrentWeek() {
        this.filter.from = moment().startOf('isoWeek').format("YYYY-MM-DD")
        this.filter.to = moment().endOf('isoWeek').format("YYYY-MM-DD")
      }
    },
    watch: {
      'filterUserId' () {
        this.queue(this.getReport())
      },
      filter: {
        handler: function() {
          this.queue(this.getReport())
        },
        deep: true
      }
    },
    mounted() {
      this.filterUserId = this.user.id
      this.background(this.getReport())
      this.background(this.getUsers())
    }

  }
</script>
